import type { ErrorComponentProps } from "@tanstack/react-router";
import { useT } from "@/i18n";
import { AccessDeniedError } from "@/lib/auth/guards";
import { errorText } from "./error-text";

/**
 * A route that failed to load. A refusal is the server's `message`. A guard
 * that refused before any request has its own sentence, because no server
 * spoke. Nothing about the request or the record is shown.
 */
export function RouteError({ error }: ErrorComponentProps) {
  const { t } = useT();

  if (error instanceof AccessDeniedError) {
    return (
      <section role="alert" className="px-pad-x py-pad-y">
        <p className="text-fs4 text-ink-1">{t("app.noAccess")}</p>
      </section>
    );
  }

  const message = errorText(error);
  if (!message) return null;

  return (
    <section role="alert" className="px-pad-x py-pad-y">
      <p className="text-fs4 text-tone-red">{message}</p>
    </section>
  );
}
